import { AfterViewInit, Component, effect, OnInit } from '@angular/core';

import { IImageParentData } from 'src/app/features/image/models/image-parent-data';
import { ILevelGeneralData } from '../../models/level-general-data';
import { _SectionModelComponent } from './_section-model-component';

@Component({
    selector: 'app-compact-section',
    template: '',
    styles: []
})
export abstract class _SectionCompactComponent<DataModel extends ILevelGeneralData>
    extends _SectionModelComponent<DataModel>
    implements OnInit, AfterViewInit
{
    constructor() {
        super();

        // De compact-sectie is de zichtbare sectie in tab-page-modus; net als
        // details/edit meldt zij de pagina af zodra het datamodel geladen is.
        // (Werkt alleen als de container (onPageLoaded) bindt — zie bv. theme.)
        effect(() => {
            if (!!this.dataModel$$()) {
                this._emit_pageLoaded();
            }
        });
    }

    protected override _ngOnInit(): void {
        const _currentPage = this._pageService.pageCurrent$$();
        const _defaultTitle = _currentPage?.displayName;
        this.headerData = {...{title: _defaultTitle}, ...this.headerData};

        // Compact provide't bewust géén CLAIM_PAGE: in tab-/medium-modus worden de edit/delete-knoppen
        // (details-slot) gevoed door de DetailsComponent, die in díé modi zelf mount. Zie
        // [[project-claim-page-token]].

        super._ngOnInit();
    }
}
